<div class="body-wrapper">
  <!-- <ngx-spinner></ngx-spinner> -->
  <app-open-vidu-data></app-open-vidu-data>
  <ngx-spinner
    bdColor="rgba(51, 51, 51, 0.8)"
    size="medium"
    color="#fff"
    type="line-scale-pulse-out"
    [fullScreen]="true"
  >
    <!-- <p style="color: white"> Please Wait... </p> -->
  </ngx-spinner>
  <router-outlet></router-outlet>
  <div class="overlay toggle-icon"></div>
</div>
